// Vietnamese translations
export const vi: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Đang tải...',
  'common.error': 'Đã xảy ra lỗi',
  'common.retry': 'Thử lại',
  'common.cancel': 'Hủy',
  'common.save': 'Lưu',
  'common.continue': 'Tiếp tục',
  'common.back': 'Quay lại',
  'common.next': 'Tiếp',
  'common.skip': 'Bỏ qua',
  'common.done': 'Xong',
  'common.yes': 'Có',
  'common.no': 'Không',
  'common.ok': 'OK',
  'common.check': 'Kiểm tra',
  'common.correct': 'Chính xác!',
  'common.incorrect': 'Sai',
  'common.tryAgain': 'Thử lại',
  'common.start': 'Bắt đầu',
  'common.finish': 'Hoàn thành',
  'common.submit': 'Gửi',

  // ==================== NAVIGATION ====================
  'nav.home': 'Trang chủ',
  'nav.courses': 'Khóa học',
  'nav.vocabulary': 'Từ vựng',
  'nav.profile': 'Hồ sơ',
  'nav.settings': 'Cài đặt',
  'nav.logout': 'Đăng xuất',
  'nav.leaderboard': 'Bảng xếp hạng',
  'nav.aiTutor': 'Gia sư AI',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'Chào mừng đến KoreanFlow!',
  'onboarding.selectLanguage': 'Chọn ngôn ngữ của bạn',
  'onboarding.selectLanguageDesc': 'Chọn ngôn ngữ cho giao diện ứng dụng',
  'onboarding.selectGoal': 'Mục tiêu học tập của bạn là gì?',
  'onboarding.selectGoalDesc': 'Chúng tôi sẽ cá nhân hóa lộ trình học của bạn',
  'onboarding.takeTest': 'Làm bài kiểm tra trình độ',
  'onboarding.takeTestDesc': 'Khám phá trình độ tiếng Hàn của bạn trong 5 phút',
  'onboarding.skipTest': 'Bỏ qua',
  'onboarding.skipTestDesc': 'Bắt đầu từ đầu',
  'onboarding.letsGo': 'Bắt đầu thôi!',
  'onboarding.step': 'Bước',
  'onboarding.of': 'của',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Kiểm tra trình độ',
  'levelTest.subtitle': 'Hãy tìm hiểu trình độ tiếng Hàn của bạn',
  'levelTest.duration': 'Khoảng 5 phút',
  'levelTest.questions': 'câu hỏi',
  'levelTest.vocabulary': 'Từ vựng',
  'levelTest.grammar': 'Ngữ pháp',
  'levelTest.listening': 'Nghe',
  'levelTest.speaking': 'Nói',
  'levelTest.analyzing': 'Đang phân tích kết quả...',
  'levelTest.yourLevel': 'Trình độ của bạn',
  'levelTest.congratulations': 'Chúc mừng!',
  'levelTest.resultDesc': 'Dựa trên kết quả bài kiểm tra',
  'levelTest.startLearning': 'Bắt đầu học',
  'levelTest.retakeTest': 'Làm lại bài kiểm tra',
  'levelTest.sectionComplete': 'Hoàn thành phần',
  'levelTest.nextSection': 'Phần tiếp theo',
  'levelTest.listenAndAnswer': 'Nghe và trả lời',
  'levelTest.speakNow': 'Nói ngay',
  'levelTest.tapToListen': 'Chạm để nghe',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Sơ cấp',
  'cefr.A2': 'Cơ bản',
  'cefr.B1': 'Trung cấp',
  'cefr.B2': 'Trung cấp cao',
  'cefr.C1': 'Nâng cao',
  'cefr.C2': 'Thành thạo',
  'cefr.A1.desc': 'Chào hỏi cơ bản và biểu đạt đơn giản',
  'cefr.A2.desc': 'Hội thoại đơn giản về cuộc sống hàng ngày',
  'cefr.B1.desc': 'Có thể xử lý hầu hết tình huống du lịch',
  'cefr.B2.desc': 'Có thể giao tiếp trôi chảy với người bản xứ',
  'cefr.C1.desc': 'Có thể diễn đạt ý tưởng trôi chảy và tự nhiên',
  'cefr.C2.desc': 'Trình độ gần như người bản xứ',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Giải đấu',
  'league.weeklyRanking': 'Xếp hạng tuần',
  'league.bronze': 'Đồng',
  'league.silver': 'Bạc',
  'league.gold': 'Vàng',
  'league.platinum': 'Bạch kim',
  'league.diamond': 'Kim cương',
  'league.promotion': 'Vùng thăng hạng',
  'league.demotion': 'Vùng xuống hạng',
  'league.safe': 'Vùng an toàn',
  'league.weeklyXP': 'XP tuần',
  'league.rank': 'Hạng',
  'league.daysLeft': 'ngày còn lại',
  'league.promoted': 'Thăng hạng!',
  'league.demoted': 'Xuống hạng',
  'league.stayed': 'Giữ nguyên',
  'league.noData': 'Chưa có dữ liệu xếp hạng',
  'league.earnXP': 'Kiếm XP để tham gia giải đấu!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'Ứng dụng học tiếng Hàn số 1',
  'landing.title': 'Học tiếng Hàn',
  'landing.titleAccent': 'một cách vui vẻ',
  'landing.subtitle': 'Thành thạo tiếng Hàn với bài học ngắn gọn, nội dung K-Pop & K-Drama, và phản hồi phát âm bằng AI. Tham gia cùng hơn 1 triệu học viên!',
  'landing.getStarted': 'Bắt đầu miễn phí',
  'landing.learnMore': 'Tìm hiểu thêm',
  'landing.login': 'Đăng nhập',
  'landing.startFree': 'Bắt đầu miễn phí',
  'landing.learners': 'Học viên',
  'landing.lessons': 'Bài học',
  'landing.countries': 'Quốc gia',

  // ==================== FEATURES ====================
  'features.title': 'Tại sao chọn KoreanFlow?',
  'features.subtitle': 'Phương pháp độc đáo kết hợp game hóa, nội dung thực tế và công nghệ AI để việc học tiếng Hàn trở nên thú vị và hiệu quả.',
  'features.streaks.title': 'Chuỗi ngày học',
  'features.streaks.desc': 'Xây dựng thói quen với mục tiêu hàng ngày và phần thưởng chuỗi. Duy trì động lực với XP và đá quý.',
  'features.folksong.title': 'Dân ca',
  'features.folksong.desc': 'Học tiếng Hàn qua dân ca truyền thống. Hiểu lời bài hát và văn hóa!',
  'features.culture.title': 'Văn hóa Hàn Quốc',
  'features.culture.desc': 'Khám phá tục ngữ, tiếng lóng và cụm từ cần thiết. Làm chủ các biểu đạt đích thực.',
  'features.ai.title': 'Chatbot AI',
  'features.ai.desc': 'Luyện hội thoại với gia sư AI. Nhận phản hồi và sửa lỗi ngay lập tức.',
  'features.leaderboard.title': 'Bảng xếp hạng',
  'features.leaderboard.desc': 'Thi đấu với bạn bè và học viên trên toàn thế giới. Leo lên bảng xếp hạng tuần!',
  'features.srs.title': 'Từ vựng SRS',
  'features.srs.desc': 'Hệ thống lặp lại thông minh đảm bảo bạn nhớ những gì đã học. Mãi mãi.',
  'features.pronunciation.title': 'Phản hồi phát âm',
  'features.pronunciation.desc': 'Phân tích phát âm bằng AI với điểm số chi tiết.',

  // ==================== CTA ====================
  'cta.title': 'Sẵn sàng bắt đầu hành trình?',
  'cta.subtitle': 'Tham gia cùng hàng triệu học viên và bắt đầu nói tiếng Hàn ngay hôm nay. Miễn phí!',
  'cta.button': 'Bắt đầu học miễn phí',

  // ==================== AUTH ====================
  'auth.login': 'Đăng nhập',
  'auth.register': 'Đăng ký',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Nhập email của bạn',
  'auth.password': 'Mật khẩu',
  'auth.passwordPlaceholder': 'Tạo mật khẩu',
  'auth.confirmPassword': 'Xác nhận mật khẩu',
  'auth.forgotPassword': 'Quên mật khẩu?',
  'auth.noAccount': 'Chưa có tài khoản?',
  'auth.haveAccount': 'Đã có tài khoản?',
  'auth.orContinueWith': 'hoặc tiếp tục với',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Tạo tài khoản',
  'auth.createAccountTitle': 'Tạo tài khoản của bạn',
  'auth.createAccountSubtitle': 'Bắt đầu hành trình học tiếng Hàn ngay hôm nay',
  'auth.username': 'Tên người dùng',
  'auth.usernamePlaceholder': 'Chọn tên người dùng',
  'auth.usernameHint': 'Chỉ chữ cái, số và dấu gạch dưới',
  'auth.passwordHint': 'Ít nhất 8 ký tự với chữ hoa, chữ thường và số',
  'auth.nativeLanguage': 'Ngôn ngữ mẹ đẻ',
  'auth.nativeLanguageHint': 'Chúng tôi sẽ hiển thị giải thích bằng ngôn ngữ này',
  'auth.termsAgree': 'Bằng cách đăng ký, bạn đồng ý với',
  'auth.terms': 'Điều khoản',
  'auth.and': 'và',
  'auth.privacyPolicy': 'Chính sách bảo mật',
  'auth.loginTitle': 'Chào mừng trở lại',
  'auth.loginSubtitle': 'Đăng nhập để tiếp tục học',
  'auth.loginButton': 'Đăng nhập',
  'auth.registerButton': 'Đăng ký',
  'auth.rememberMe': 'Ghi nhớ tôi',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Chào mừng trở lại',
  'dashboard.todayGoal': 'Mục tiêu hôm nay',
  'dashboard.streak': 'Chuỗi',
  'dashboard.days': 'ngày',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Cấp độ',
  'dashboard.continueLearning': 'Tiếp tục học',
  'dashboard.recommended': 'Đề xuất cho bạn',
  'dashboard.myCourses': 'Khóa học của tôi',
  'dashboard.seeAll': 'Xem tất cả',
  'dashboard.dailyGoalComplete': 'Hoàn thành mục tiêu hàng ngày!',
  'dashboard.keepGoing': 'Tiếp tục phát huy!',
  'dashboard.yourLevel': 'Trình độ của bạn',
  'dashboard.weeklyProgress': 'Tiến độ tuần',

  // ==================== COURSES ====================
  'courses.title': 'Tất cả khóa học',
  'courses.search': 'Tìm khóa học...',
  'courses.all': 'Tất cả',
  'courses.beginner': 'Sơ cấp',
  'courses.elementary': 'Cơ bản',
  'courses.intermediate': 'Trung cấp',
  'courses.advanced': 'Nâng cao',
  'courses.lessons': 'bài học',
  'courses.enrolled': 'đã đăng ký',
  'courses.progress': 'Tiến độ',
  'courses.completed': 'hoàn thành',
  'courses.recommended': 'Đề xuất',
  'courses.forYourLevel': 'Phù hợp với trình độ',
  'courses.locked': 'Đã khóa',
  'courses.unlockWith': 'Mở khóa với Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'Đang tải bài học...',
  'lesson.notFound': 'Không tìm thấy bài học',
  'lesson.quit': 'Bạn có chắc muốn thoát? Tiến độ sẽ bị mất.',
  'lesson.complete': 'Hoàn thành bài học!',
  'lesson.perfect': 'Hoàn hảo!',
  'lesson.amazing': 'Tuyệt vời! Bạn trả lời đúng hết!',
  'lesson.xpEarned': 'XP đã kiếm',
  'lesson.accuracy': 'Độ chính xác',
  'lesson.correct': 'Đúng',
  'lesson.goBack': 'Quay lại',
  'lesson.skip': 'Bỏ qua',
  'lesson.unknownType': 'Loại bài tập không xác định',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Chạm để xem đáp án',
  'exercise.matchPairs': 'Ghép cặp',
  'exercise.matched': 'đã ghép',
  'exercise.arrangeWords': 'Sắp xếp từ',
  'exercise.speak': 'Nói',
  'exercise.listening': 'Đang nghe... Nói ngay!',
  'exercise.processing': 'Đang xử lý giọng nói...',
  'exercise.tapToSpeak': 'Chạm để nói',
  'exercise.cantSpeak': 'Không thể nói bây giờ? Bỏ qua',
  'exercise.again': 'Lại',
  'exercise.gotIt': 'Hiểu rồi!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Luyện phát âm',
  'pronunciation.subtitle': 'Cải thiện phát âm tiếng Hàn với phản hồi AI',
  'pronunciation.selectLevel': 'Chọn trình độ',
  'pronunciation.beginner': 'Sơ cấp',
  'pronunciation.intermediate': 'Trung cấp',
  'pronunciation.advanced': 'Nâng cao',
  'pronunciation.score': 'Điểm của bạn',
  'pronunciation.accuracy': 'Độ chính xác',
  'pronunciation.fluency': 'Trôi chảy',
  'pronunciation.intonation': 'Ngữ điệu',
  'pronunciation.feedback': 'Phản hồi',
  'pronunciation.tryAgain': 'Thử lại',
  'pronunciation.next': 'Tiếp',
  'pronunciation.listen': 'Nghe',
  'pronunciation.slow': 'Chậm',
  'pronunciation.sessionComplete': 'Hoàn thành buổi học!',
  'pronunciation.bestScore': 'Điểm cao nhất',
  'pronunciation.average': 'Trung bình',
  'pronunciation.attempts': 'Số lần thử',
  'pronunciation.practiceAgain': 'Luyện tập lại',
  'pronunciation.changeLevel': 'Đổi trình độ',
  'pronunciation.tips': 'Mẹo phát âm tốt hơn',
  'pronunciation.tip1': 'Nghe audio trước',
  'pronunciation.tip2': 'Nói rõ ràng và đều đặn',
  'pronunciation.tip3': 'Dùng phát lại chậm cho từ khó',
  'pronunciation.tip4': 'Luyện tập trong môi trường yên tĩnh',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Từ vựng',
  'vocab.totalWords': 'Tổng số từ',
  'vocab.mastered': 'Đã thành thạo',
  'vocab.dueToday': 'Hôm nay',
  'vocab.reviewSession': 'Buổi ôn tập',
  'vocab.wordsDue': 'từ cần ôn',
  'vocab.startReview': 'Bắt đầu ôn tập',
  'vocab.allCaughtUp': 'Đã ôn hết!',
  'vocab.noWordsDue': 'Không có từ cần ôn',
  'vocab.sessionComplete': 'Hoàn thành buổi học!',
  'vocab.allWords': 'Tất cả từ',

  // ==================== PROFILE ====================
  'profile.title': 'Hồ sơ',
  'profile.level': 'Cấp độ',
  'profile.xpToNext': 'XP đến cấp tiếp theo',
  'profile.totalXp': 'Tổng XP',
  'profile.currentStreak': 'Chuỗi hiện tại',
  'profile.lessonsDone': 'Bài học đã hoàn thành',
  'profile.timeLearned': 'Thời gian học',
  'profile.achievements': 'Thành tích',
  'profile.settings': 'Cài đặt',
  'profile.dailyGoals': 'Mục tiêu hàng ngày',
  'profile.allAchievements': 'Tất cả thành tích',
  'profile.logOut': 'Đăng xuất',
  'profile.koreanLevel': 'Trình độ tiếng Hàn',

  // ==================== SETTINGS ====================
  'settings.title': 'Cài đặt',
  'settings.language': 'Ngôn ngữ ứng dụng',
  'settings.preferences': 'Tùy chọn',
  'settings.sound': 'Hiệu ứng âm thanh',
  'settings.soundEffects': 'Hiệu ứng âm thanh',
  'settings.soundEffectsDesc': 'Phát âm thanh khi trả lời bài tập',
  'settings.notifications': 'Thông báo',
  'settings.notificationsDesc': 'Nhận nhắc nhở học tập hàng ngày',
  'settings.darkMode': 'Chế độ tối',
  'settings.darkModeDesc': 'Giao diện tối để xem thoải mái hơn',
  'settings.dailyReminder': 'Nhắc nhở hàng ngày',
  'settings.account': 'Tài khoản',
  'settings.editProfile': 'Chỉnh sửa hồ sơ',
  'settings.privacy': 'Quyền riêng tư',
  'settings.help': 'Trợ giúp',
  'settings.about': 'Giới thiệu',
  'settings.retakeTest': 'Làm lại bài kiểm tra trình độ',
  'settings.retakeTestDesc': 'Kiểm tra trình độ tiếng Hàn hiện tại',
  'settings.terms': 'Điều khoản dịch vụ',

  // ==================== FOOTER ====================
  'footer.privacy': 'Quyền riêng tư',
  'footer.terms': 'Điều khoản',
  'footer.contact': 'Liên hệ',
  'footer.rights': 'Đã đăng ký bản quyền.',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Từ vựng',
  'quickAction.reviewWords': 'Ôn từ vựng',
  'quickAction.allCourses': 'Tất cả khóa học',
  'quickAction.browseLessons': 'Duyệt bài học',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Không tìm thấy khóa học',
  'courseDetail.lessons': 'bài học',
  'courseDetail.completed': 'hoàn thành',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Trang chủ',
  'bottomNav.courses': 'Khóa học',
  'bottomNav.vocab': 'Từ vựng',
  'bottomNav.profile': 'Hồ sơ',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'Gia sư AI',
  'aiTutor.selectScenario': 'Chọn tình huống',
  'aiTutor.freeTalk': 'Trò chuyện tự do',
  'aiTutor.cafe': 'Gọi đồ ở quán cafe',
  'aiTutor.shopping': 'Mua sắm',
  'aiTutor.restaurant': 'Nhà hàng',
  'aiTutor.friends': 'Kết bạn',
  'aiTutor.interview': 'Phỏng vấn xin việc',
  'aiTutor.typeMessage': 'Nhập tin nhắn...',
  'aiTutor.send': 'Gửi',

  // ==================== ERRORS ====================
  'error.generic': 'Đã xảy ra lỗi',
  'error.network': 'Lỗi mạng. Vui lòng kiểm tra kết nối.',
  'error.notFound': 'Không tìm thấy trang',
  'error.unauthorized': 'Vui lòng đăng nhập để tiếp tục',
  'error.microphoneAccess': 'Quyền truy cập micro bị từ chối',
  'error.speechNotSupported': 'Nhận dạng giọng nói không được hỗ trợ. Hãy thử Chrome.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Chúng tôi sử dụng cookie',
  'cookie.description': 'Chúng tôi sử dụng cookie để cải thiện trải nghiệm của bạn, phân tích lưu lượng truy cập và cá nhân hóa nội dung. Bạn có thể chọn chấp nhận hoặc từ chối cookie không cần thiết.',
  'cookie.learnMore': 'Tìm hiểu thêm',
  'cookie.acceptAll': 'Chấp nhận tất cả',
  'cookie.rejectAll': 'Từ chối tất cả',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Học',
  'nav.culture': 'Văn hóa',
  'nav.chat': 'Trò chuyện',
  'nav.ranking': 'Xếp hạng',
  'nav.family': 'Gia đình',
  'nav.premium': 'Premium',
  'home.greeting': 'Xin chào',
  'home.streak': 'ngày liên tiếp',
  'home.dailyGoal': 'Mục tiêu hằng ngày',
  'home.myLanguages': 'Ngôn ngữ của tôi',
  'home.addLanguage': 'Thêm ngôn ngữ',
  'home.recommended': 'Gợi ý cho bạn',
  'home.continue': 'Tiếp tục học',
  'home.selectLanguage': 'Chọn ngôn ngữ',
  'home.totalXp': 'Tổng XP',
  'home.bestStreak': 'Chuỗi dài nhất',
  'home.level': 'Cấp độ',
  'chat.aiTutor': 'Gia sư AI',
  'chat.aiTutorDesc': 'Luyện hội thoại cùng AI',
  'onboarding.welcome.subtitle': 'Học mọi ngôn ngữ qua hội thoại với AI',
  'onboarding.selectUILanguage': 'Chọn ngôn ngữ của bạn',
  'onboarding.selectUILanguage.subtitle': 'Dùng cho giao diện ứng dụng',
  'onboarding.selectLearningLanguage': 'Bạn muốn học gì?',
  'onboarding.selectLearningLanguage.subtitle': 'Bạn có thể học nhiều ngôn ngữ',
  'onboarding.selectDailyGoal': 'Đặt mục tiêu hằng ngày',
  'onboarding.selectDailyGoal.subtitle': 'Mỗi ngày bạn dành được bao nhiêu thời gian?',
  'onboarding.ready': 'Tất cả đã sẵn sàng!',
  'onboarding.ready.subtitle': 'Bắt đầu hành trình học ngôn ngữ của bạn nào',
  'onboarding.features.languages': '4 ngôn ngữ',
  'onboarding.features.aiTutor': 'Gia sư AI',
  'onboarding.features.dailyGoals': 'Mục tiêu hằng ngày',
  'dailyGoal.5min': '5 phút',
  'dailyGoal.10min': '10 phút',
  'dailyGoal.15min': '15 phút',
  'dailyGoal.20min': '20 phút',
  'dailyGoal.casual': 'Nhẹ nhàng',
  'dailyGoal.regular': 'Luyện tập đều đặn',
  'dailyGoal.serious': 'Học nghiêm túc',
  'dailyGoal.intense': 'Luyện tập cường độ cao',
  'learn.title': 'Học',
  'learn.currentLevel': 'Cấp độ hiện tại',
  'learn.noCoursesYet': 'Sắp ra mắt!',
  'learn.noCoursesDescription': 'Các khóa học cho ngôn ngữ này đang được chuẩn bị.',
  'learn.lessonsCompleted': 'bài đã hoàn thành',
  'learn.startCourse': 'Bắt đầu khóa học',
  'learn.continueCourse': 'Tiếp tục',
  'learn.courseCompleted': 'Đã hoàn thành',
  'learn.locked': 'Đã khóa',
  'learn.unlockBy': 'Hoàn thành khóa trước để mở khóa',
  'course.progress': 'Tiến độ',
  'course.lessons': 'Bài học',
  'course.lessonsCompleted': 'bài đã hoàn thành',
  'course.noLessons': 'Các bài học đang được chuẩn bị...',
  'lesson.tapToReveal': 'Chạm để xem nghĩa',
  'lesson.examples': 'Ví dụ',
  'lesson.questionsCorrect': 'đúng',
  'lesson.wordsLearned': 'Từ vựng',
  'lesson.grammarPoints': 'Ngữ pháp',
  'lesson.backToCourse': 'Về khóa học',
  'lesson.practiceAgain': 'Luyện lại',
  'lesson.whatYouLearn': 'Bạn sẽ học được gì',
  'lesson.newWords': 'từ mới',
  'lesson.exercises': 'bài tập',
  'lesson.startLesson': 'Bắt đầu bài học',
  'lesson.reviewLesson': 'Ôn lại bài',
  'lesson.learnVocabulary': 'Học từ vựng',
  'lesson.grammarPoint': 'Điểm ngữ pháp',
  'lesson.practice': 'Luyện tập',
  'profile.guest': 'Khách',
  'profile.days': 'ngày',
  'profile.longestStreak': 'Dài nhất',
  'profile.lessonsCompleted': 'đã hoàn thành',
  'profile.dailyGoal': 'Mục tiêu hằng ngày',
  'profile.learningLanguages': 'Ngôn ngữ đang học',
  'profile.noLanguages': 'Chưa chọn ngôn ngữ',
  'profile.minutesPerDay': 'phút/ngày',
  'profile.learningHistory': 'Lịch sử học tập',
  'profile.viewProgress': 'Xem tiến độ của bạn',
  'profile.appSettings': 'Cài đặt ứng dụng',
  'profile.languageNotifications': 'Ngôn ngữ, thông báo',
  'profile.loginToSave': 'Đăng nhập để lưu tiến độ',
  'settings.learning': 'Học tập',
  'settings.dailyGoal': 'Mục tiêu hằng ngày',
  'settings.minutesPerDay': 'phút mỗi ngày',
  'settings.selectLanguage': 'Chọn ngôn ngữ',
  'settings.selectDailyGoal': 'Đặt mục tiêu hằng ngày',
  'settings.perDay': 'mỗi ngày',
  'settings.appInfo': 'Thông tin ứng dụng',
  'settings.logout': 'Đăng xuất',
};

export default vi;
